import React from "react";
import { Modal } from "antd";
import { getPaymentMethodInFrench } from "../../utils/payment";

const TicketModal = ({ open, onCancel, ticket }) => (
  <Modal
    title="Détails du Ticket de Parking"
    open={open}
    onCancel={onCancel}
    footer={null}
  >
    {ticket && (
      <div>
        <p>
          <strong>ID Ticket:</strong> {ticket.id}
        </p>
        <p>
          <strong>Référence:</strong> {ticket.reference}
        </p>
        <p>
          <strong>Date de début:</strong> {ticket.start_date}
        </p>
        <p>
          <strong>Date de fin:</strong> {ticket.end_date}
        </p>
        <p>
          <strong>Méthode de paiement:</strong>{" "}
          {getPaymentMethodInFrench(ticket.payment_method)}
        </p>
        <p>
          <strong>Montant:</strong> {ticket.amount}
        </p>
        <p>
          <strong>Matricule:</strong> {ticket.vehicle_number || "N/A"}
        </p>
      </div>
    )}
  </Modal>
);

export default TicketModal;
